import React, { useEffect, useState } from 'react'
import logo from '../pictures/TheBestescafflogo.png'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAdaption, fetchSingleJobsForStaffMember, jobStatusComplete, jobStatusStart } from '../store/staffSlice';
import URL from '../functions/URLString';
import googleMaps from '../pictures/googleMaps.png'
import { json, useNavigate } from 'react-router-dom';
import StaffLogo from '../components/StaffLogo';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PendingIcon from '@mui/icons-material/Pending';

const details = [
  {
    key:"dynamicOBJ",
    display:"dynamic objectmap",
  },
  {
    key:"WeeklyScaffoldingInspections",
    display:"Weekly Scaffolding Inspections",
  },
]

function StaffJob() {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(window.location.search)
  const id = queryParameters.get("id")
  const type = queryParameters.get("type")
  const stateSingleJobsForStaffMember = useSelector((state) => state.staff.singlejobsForStaffMember)
  const adaptionDetails = useSelector((state) => state.staff.adaptionDetails)
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [data, setData] = useState({jobDescription:"",job1:"",job2:"",jobDetails:"",status:0});
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(()=>{
    dispatch(fetchSingleJobsForStaffMember({_id:id}))
    dispatch(fetchAdaption({jobID:id,type}))
  },[])

  useEffect(()=>{
    if(JSON.stringify(stateSingleJobsForStaffMember)!=="{}"){
      setImages(stateSingleJobsForStaffMember.Images || []);
      setData({
        ...data,
        jobDescription:stateSingleJobsForStaffMember.jobDescription,
        job1:stateSingleJobsForStaffMember.job1,
        job2:stateSingleJobsForStaffMember.job2,
        jobDetails:stateSingleJobsForStaffMember.jobDetails,
        status:stateSingleJobsForStaffMember.status
      });
      setIsLoading(false);
    }
  },[stateSingleJobsForStaffMember])

  const handleStatusSt = (e) => {
    e.preventDefault();
    dispatch(jobStatusStart({ jobID: id }));
  }

  const handleStatusCm = () => {
    dispatch(jobStatusComplete({ jobID: id }));
  }

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleImageSelect = (index) => {
    setCurrentImageIndex(index);
  };

  const getStatusInfo = () => {
    switch(data.status) {
      case 0:
        return { icon: <PendingIcon className="text-yellow-500" />, text: "Pending", color: "text-yellow-600" };
      case 1:
        return { icon: <PlayCircleIcon className="text-blue-500" />, text: "In Progress", color: "text-blue-600" };
      case 2:
        return { icon: <CheckCircleIcon className="text-green-500" />, text: "Completed", color: "text-green-600" };
      default:
        return { icon: <PendingIcon className="text-gray-500" />, text: "Unknown", color: "text-gray-600" };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <div className='w-full h-screen bg-gray-50'>
      {/* Desktop Warning */}
      <div className='hidden lg:flex w-full h-screen items-center justify-center'>
        <div className="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-lg max-w-lg">
          <strong className="font-bold text-lg">Warning!</strong>
          <p className="mt-2">This page is only visible on mobile and tablet devices.</p>
        </div>
      </div>

      {/* Mobile/Tablet Layout */}
      <div className='lg:hidden flex flex-col h-screen'>
        {/* Header */}
        <div className='bg-white shadow-sm px-4 py-3 flex items-center justify-between'>
          <div className='flex items-center space-x-3'>
            <button 
              onClick={() => navigate("/staffjoblist")} 
              className='text-gray-600 hover:text-lightgreen transition-colors'
            >
              <ArrowBackIcon />
            </button>
            <h1 className='text-xl font-semibold text-gray-800'>Job Details</h1>
          </div>
          <button 
            onClick={() => navigate("/staffjoblist")} 
            className='text-gray-500 hover:text-lightgreen transition-colors'
          >
            <CloseIcon />
          </button>
          </div>

        {/* Main Content */}
        <div className='flex-1 overflow-y-auto'>
          {isLoading ? (
            <div className='flex items-center justify-center h-full'>
              <CircularProgress className='align-middle' size={60} color="success"/>
            </div>
          ) : (
            <>
              {/* Image Slider Section */}
              <div className='bg-white p-4'>
                {images.length > 0 ? (
                  <div className='space-y-4'>
                    {/* Main Image */}
                    <div className='relative aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden'>
                      <img 
                        className='w-full h-full object-contain' 
                        src={`${URL}/uploads/${images[currentImageIndex]}`} 
                        alt={`Job ${currentImageIndex + 1}`} 
                      />
                      
                      {/* Navigation Arrows */}
                      {images.length > 1 && (
                        <>
                          <button 
                            onClick={handlePrevImage}
                            className='absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors'
                          >
                            <ArrowBackIosNewIcon fontSize="small" />
                          </button>
                          <button 
                            onClick={handleNextImage}
                            className='absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-colors'
                          >
                            <ArrowForwardIosIcon fontSize="small" />
                          </button>
                        </>
                      )}
                      
                      {/* Image Counter */}
                      <div className='absolute bottom-2 right-2 bg-black/50 text-white px-2 py-1 rounded text-sm'>
                        {currentImageIndex + 1} / {images.length}
                      </div>
              </div>

                    {/* Thumbnail Gallery */}
                    {images.length > 1 && (
                      <div className='flex gap-2 overflow-x-auto pb-2 scrollbar-hide'>
                        {images.map((image, index) => (
                          <button
                            key={index}
                            onClick={() => handleImageSelect(index)}
                            className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all ${
                              currentImageIndex === index 
                                ? 'border-lightgreen shadow-md' 
                                : 'border-gray-200 hover:border-gray-300'
                            }`}
                          >
                            <img 
                              src={`${URL}/uploads/${image}`} 
                              alt={`Thumbnail ${index + 1}`}
                              className='w-full h-full object-cover'
                            />
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='aspect-[4/3] bg-gray-100 rounded-lg flex items-center justify-center'>
                    <p className='text-gray-500'>No images available</p>
                  </div>
                )}
              </div>

              {/* Status Card */}
              <div className='mx-4 mb-4'>
                <div className='bg-white rounded-lg shadow-sm p-4 flex items-center justify-between'>
                  <div className='flex items-center space-x-3'>
                    {statusInfo.icon}
                    <div>
                      <p className='text-sm text-gray-500'>Status</p>
                      <p className={`font-semibold ${statusInfo.color}`}>{statusInfo.text}</p>
                    </div>
                </div>
                  {data.status === 0 && (
                    <button 
                      onClick={handleStatusSt}
                      className='px-4 py-2 bg-lightgreen hover:bg-darkgreen text-white rounded-lg font-medium transition-colors shadow-sm'
                    >
                      Start Job
                    </button>
                  )}
                  {data.status === 1 && (
                    <button 
                      onClick={handleStatusCm}
                      className='px-4 py-2 bg-lightgreen hover:bg-darkgreen text-white rounded-lg font-medium transition-colors shadow-sm'
                    >
                      Complete
                    </button>
                  )}
                </div>
              </div>

              {/* Job Details Section */}
              <div className='mx-4 mb-4 space-y-4'>
                {/* Basic Details Card */}
                <div className='bg-white rounded-lg shadow-sm p-4 space-y-3'>
                  <h2 className='font-semibold text-gray-800 text-lg mb-3'>Job Information</h2>
                  
                  <div className='flex items-start space-x-3'>
                    <LocationOnIcon className='text-gray-400 mt-0.5' fontSize="small" />
                    <div className='flex-1'>
                      <p className='text-sm text-gray-500'>Address</p>
                      <p className='text-gray-800'>{data.job1} {data.job2}</p>
                    </div>
                  </div>

                  <div className='flex items-start space-x-3'>
                    <DescriptionIcon className='text-gray-400 mt-0.5' fontSize="small" />
                    <div className='flex-1'>
                      <p className='text-sm text-gray-500'>Description</p>
                      <p className='text-gray-800'>{data.jobDescription || 'No description available'}</p>
                    </div>
            </div>

                  <div className='flex items-start space-x-3'>
                    <AccessTimeIcon className='text-gray-400 mt-0.5' fontSize="small" />
                    <div className='flex-1'>
                      <p className='text-sm text-gray-500'>Access</p>
                      <p className='text-gray-800'>{data.jobDetails || 'No access details'}</p>
                </div>
                </div>
                </div>

                {/* Adaption Details Card */}
                {adaptionDetails && (
                  <div className='bg-white rounded-lg shadow-sm p-4'>
                    <h2 className='font-semibold text-gray-800 text-lg mb-3'>Quotation Details</h2>
                    
                    {adaptionDetails.type === "temproryRoofQoute" ? (
                      <div className='space-y-3'>
                        {parseInt(adaptionDetails.permiterOfBuilding) > 0 && (
                          <div className='border-l-4 border-lightgreen pl-3 py-1'>
                            <p className='text-sm text-gray-500'>Perimeter of building</p>
                            <p className='font-medium text-gray-800'>{adaptionDetails.permiterOfBuilding} meters</p>
                            <p className='text-sm text-gray-600'>Number of lifts: {adaptionDetails.numberOfLiftsForPerimeter}</p>
                          </div>
                        )}
                        {parseInt(adaptionDetails.widthOfBuilding) > 0 && (
                          <div className='border-l-4 border-lightgreen pl-3 py-1'>
                            <p className='text-sm text-gray-500'>Building dimensions</p>
                            <p className='font-medium text-gray-800'>
                              {adaptionDetails.widthOfBuilding}m × {adaptionDetails.lengthOfBuilding}m
                            </p>
                          </div>
                        )}
                          </div>
                    ) : (
                      <div className='space-y-3'>
                        {/* Dynamic Objects */}
                        {adaptionDetails.dynamicOBJ?.length > 0 && (
                          <div className='space-y-2'>
                            <p className='text-sm font-medium text-gray-700'>Elevations</p>
                            {adaptionDetails.dynamicOBJ.map((item, index) => (
                              <div key={index} className='bg-gray-50 rounded-lg p-3'>
                                <p className='font-medium text-gray-800'>{item.elevationNamee}</p>
                                <div className='grid grid-cols-2 gap-2 mt-1'>
                                  <p className='text-sm text-gray-600'>Length: {item.elevationLength}m</p>
                                  <p className='text-sm text-gray-600'>Lifts: {item.elevationLifts}</p>
                          </div>
                          </div>
                            ))}
                          </div>
                        )}

                        {/* Gantry Details */}
                        {adaptionDetails.gantryElevation?.length > 0 && (
                          <div className='border-l-4 border-blue-400 pl-3 py-1'>
                            <p className='text-sm font-medium text-gray-700'>Gantry</p>
                            <p className='text-gray-800'>{adaptionDetails.gantryElevation}</p>
                            <div className='grid grid-cols-3 gap-2 mt-1'>
                              <p className='text-sm text-gray-600'>L: {adaptionDetails.gantryLength}m</p>
                              <p className='text-sm text-gray-600'>W: {adaptionDetails.gantryWidth}m</p>
                              <p className='text-sm text-gray-600'>Lifts: {adaptionDetails.gantryLift}</p>
                          </div>
                          </div>
                        )}

                        {/* Bay Details */}
                        {adaptionDetails.bayElevation?.length > 0 && (
                          <div className='border-l-4 border-purple-400 pl-3 py-1'>
                            <p className='text-sm font-medium text-gray-700'>Bay</p>
                            <p className='text-gray-800'>{adaptionDetails.bayElevation}</p>
                            <div className='grid grid-cols-3 gap-2 mt-1'>
                              <p className='text-sm text-gray-600'>L: {adaptionDetails.baylength}m</p>
                              <p className='text-sm text-gray-600'>W: {adaptionDetails.bayWidth}m</p>
                              <p className='text-sm text-gray-600'>Lifts: {adaptionDetails.bayLift}</p>
                          </div>
                          </div>
                        )}

                        {/* Deck Details */}
                        {parseInt(adaptionDetails.deckLength) > 0 && (
                          <div className='border-l-4 border-orange-400 pl-3 py-1'>
                            <p className='text-sm font-medium text-gray-700'>Bird Cage/Crash Deck</p>
                            <div className='grid grid-cols-3 gap-2 mt-1'>
                              <p className='text-sm text-gray-600'>L: {adaptionDetails.deckLength}m</p>
                              <p className='text-sm text-gray-600'>W: {adaptionDetails.deckWidth}m</p>
                              <p className='text-sm text-gray-600'>Lifts: {adaptionDetails.deckLift}</p>
                          </div>
                          </div>
                        )}

                        {/* Accessories Grid */}
                        <div className='grid grid-cols-2 gap-3'>
                          {parseInt(adaptionDetails.hopUp) > 0 && (
                            <div className='bg-gray-50 rounded-lg p-3'>
                              <p className='text-sm text-gray-500'>Hop-Ups</p>
                              <p className='font-medium text-gray-800'>{adaptionDetails.hopUp}</p>
                          </div>
                          )}
                          {parseInt(adaptionDetails.saddle) > 0 && (
                            <div className='bg-gray-50 rounded-lg p-3'>
                              <p className='text-sm text-gray-500'>Saddles</p>
                              <p className='font-medium text-gray-800'>{adaptionDetails.saddle}</p>
                          </div>
                      )}
                          {parseInt(adaptionDetails.throwIn) > 0 && (
                            <div className='bg-gray-50 rounded-lg p-3'>
                              <p className='text-sm text-gray-500'>Throw-Ins</p>
                              <p className='font-medium text-gray-800'>{adaptionDetails.throwIn}</p>
                        </div>
                      )}
                        </div>

                        {/* Towers */}
                        <div className='space-y-2'>
                          {parseInt(adaptionDetails.fiveFootTower) > 0 && (
                            <div className='flex justify-between items-center py-2 border-b border-gray-100'>
                              <span className='text-sm text-gray-600'>5 foot/1.8m tower</span>
                              <span className='font-medium'>{adaptionDetails.fiveFootTower} × {adaptionDetails.fiveFootTowerLift} lifts</span>
                        </div>
                      )}
                          {parseInt(adaptionDetails.eightFootTower) > 0 && (
                            <div className='flex justify-between items-center py-2 border-b border-gray-100'>
                              <span className='text-sm text-gray-600'>8 foot/2.4m tower</span>
                              <span className='font-medium'>{adaptionDetails.eightFootTower} × {adaptionDetails.eightFootTowerLift} lifts</span>
                          </div>
                      )}
                          {parseInt(adaptionDetails.tenFootTower) > 0 && (
                            <div className='flex justify-between items-center py-2 border-b border-gray-100'>
                              <span className='text-sm text-gray-600'>10 foot/3.0m tower</span>
                              <span className='font-medium'>{adaptionDetails.tenFootTower} × {adaptionDetails.tenFootTowerLift} lifts</span>
                          </div>
                      )}
                          {parseInt(adaptionDetails.thirteenFootTower) > 0 && (
                            <div className='flex justify-between items-center py-2 border-b border-gray-100'>
                              <span className='text-sm text-gray-600'>13 foot/4.0m tower</span>
                              <span className='font-medium'>{adaptionDetails.thirteenFootTower} × {adaptionDetails.thirteenFootTowerLift} lifts</span>
                          </div>
                      )}
                          </div>

                        {/* Additional Items */}
                        {adaptionDetails.additionalItem?.length > 0 && (
                          <div className='space-y-2'>
                            <p className='text-sm font-medium text-gray-700'>Additional Items</p>
                            {adaptionDetails.additionalItem.map((item, index) => (
                              <div key={index} className='flex justify-between items-center py-2 bg-gray-50 px-3 rounded'>
                                <span className='text-sm text-gray-600'>{item.additionalItemName}</span>
                                <span className='font-medium text-gray-800'>×{item.numberOfadditionalItem}</span>
                          </div>
                            ))}
                          </div>
                        )}
              </div>
                  )}
                </div>
                )}
            </div>
            
              {/* Action Buttons */}
              <div className='mx-4 mb-4 pb-safe'>
                <button 
                  onClick={(e)=>navigate(`/staffform?id=${stateSingleJobsForStaffMember.customer._id}&clientName=${stateSingleJobsForStaffMember.customer.customerCompanyName}&address=${stateSingleJobsForStaffMember.job1+" "+stateSingleJobsForStaffMember.job2}&postcode=${stateSingleJobsForStaffMember.customer.postcode}&adminName=${stateSingleJobsForStaffMember.adminID.fullName}&adminName=${stateSingleJobsForStaffMember.adminID.fullName}&adminemail=${stateSingleJobsForStaffMember.adminID.email}&adminID=${stateSingleJobsForStaffMember.adminID._id}`)}
                  className='w-full px-6 py-3 bg-lightgreen hover:bg-darkgreen text-white rounded-lg font-medium transition-colors shadow-sm'
                >
                  Hand Over
                </button>
            </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default StaffJob